import type { Snapshot } from "../types";
import { STYLES } from "../data/styles";
import { fmtTemp } from "../lib/format";

export const HISTORY_KEY = "pdc:history";
export const HISTORY_MAX = 24;
export const YEAST_LABEL: Record<string, string> = {
  idy: "IDY", ady: "ADY", fresh: "Fresh", sourdough: "Sourdough",
};

/* Everything except the timestamp/id, for dedup. */
export function stateKey(s: Snapshot): string {
  const { ts, id, ...rest } = s;
  return JSON.stringify(rest);
}

export function snapName(s: Snapshot): string {
  return STYLES.find((x) => x.id === s.style)?.name || s.style;
}
export function snapMeta(s: Snapshot): string {
  return `${s.count}×${s.unitWeight}g · ${YEAST_LABEL[s.yeast] || s.yeast} · ` +
         `${s.time}h @ ${fmtTemp(s.temp)}°C · ${s.hydration}% hyd`;
}

export function loadHistory(): Snapshot[] {
  try { return JSON.parse(localStorage.getItem(HISTORY_KEY) || "") || []; }
  catch { return []; }
}
export function saveHistory(list: Snapshot[]): void {
  try { localStorage.setItem(HISTORY_KEY, JSON.stringify(list)); }
  catch { /* storage full or blocked; ignore */ }
}

export function addToHistory(snap: Snapshot): Snapshot[] {
  snap.ts = Date.now();
  snap.id = snap.ts.toString(36) + Math.random().toString(36).slice(2, 6);
  const key = stateKey(snap);
  let list = loadHistory().filter((e) => stateKey(e) !== key);
  list.unshift(snap);
  if (list.length > HISTORY_MAX) list = list.slice(0, HISTORY_MAX);
  saveHistory(list);
  return list;
}
